"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateClientMutation = exports.useGetClientsQuery = exports.useGetMyClientQuery = exports.useGetClientQuery = exports.clientApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.clientApi = (0, react_1.createApi)({
    reducerPath: "clientApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["client"],
    endpoints: function (builder) { return ({
        getClient: builder.query({
            query: function (id) { return "/v1/client/".concat(id); },
            providesTags: ["client"],
        }),
        getMyClient: builder.query({
            query: function () { return "/v1/client/me"; },
            keepUnusedDataFor: 0,
            providesTags: ["client"],
        }),
        getClients: builder.query({
            query: function (pagination) {
                var request = (pagination || {});
                return (0, api_url_1.appendUrlParams)("/v1/client", {
                    size: request.size,
                    pageNumber: request.pageNumber,
                    search: request.search,
                    sortBy: request.sortBy,
                    sortDirection: request.sortDirection,
                });
            },
            providesTags: ["client"],
        }),
        updateClient: builder.mutation({
            query: function (_a) {
                var id = _a.id, body = __rest(_a, ["id"]);
                return ({
                    url: "/v1/client/".concat(id),
                    method: "PATCH",
                    body: body,
                });
            },
            invalidatesTags: ["client"],
        }),
    }); },
});
exports.useGetClientQuery = exports.clientApi.useGetClientQuery, exports.useGetMyClientQuery = exports.clientApi.useGetMyClientQuery, exports.useGetClientsQuery = exports.clientApi.useGetClientsQuery, exports.useUpdateClientMutation = exports.clientApi.useUpdateClientMutation;
